export default __webpack_public_path__ + "static/media/search.ebf291ae.svg";